import auth from '../services/auth'

export default {
  computed: {
    userData () {
      return auth._clientData
    }
  }
}
